module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "6em"
    },
    attrs: {
      "id": "firebaseui-auth-wrapper"
    }
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Sign In")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "firebaseui-auth-container"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c1e677f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Auth.vue
// module id = 120
// module chunks = 2